"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var _1 = require("./");
function tooltipFactory(WrappedComponent, props) {
    var EnhancedComponent = /** @class */ (function (_super) {
        tslib_1.__extends(EnhancedComponent, _super);
        function EnhancedComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EnhancedComponent.prototype.render = function () {
            var _a = this.props, title = _a.title, position = _a.position, delay = _a.delay, show = _a.show, leaveOpenOnMouseOver = _a.leaveOpenOnMouseOver, others = tslib_1.__rest(_a, ["title", "position", "delay", "show", "leaveOpenOnMouseOver"]);
            var tooltipProps = tslib_1.__assign({}, props);
            position && (tooltipProps.position = position);
            delay && (tooltipProps.delay = delay);
            title && (tooltipProps.title = title);
            show && (tooltipProps.show = show);
            leaveOpenOnMouseOver && (tooltipProps.leaveOpenOnMouseOver = leaveOpenOnMouseOver);
            return (React.createElement(_1.default, tslib_1.__assign({}, tooltipProps),
                React.createElement(WrappedComponent, tslib_1.__assign({}, others))));
        };
        return EnhancedComponent;
    }(React.Component));
    EnhancedComponent.displayName = "TooltipFactory(" + utils_1.getDisplayName(WrappedComponent) + ")";
    return EnhancedComponent;
}
exports.default = tooltipFactory;
